export enum UserRoles {
  Customer = "customer",
  Agent = "agent",
  Admin = "admin",
}
